export default "Review on the way ...\n\n<!-- Diana & Marie og Jimmy & Thomas -->";